import { TPermissionsStoreState } from './types';

export function getPermissions(state: TPermissionsStoreState) {
  return state.permissions;
}
